import {Flex} from 'antd';
import React from 'react';

import {formatIndian} from '../../../../utils/formatIndian';
import {convertGjToTjWithUnit} from '../../../../utils/formatValueWithUnit';
import CircleComponent from '../../components/CircleComponent';
import {collageOfColors} from '../../constants/commonConstants';

const FlexLegend: React.FC<{
  index: number;
  item: any;
  isValue: boolean;
  convertToTJ?: boolean;
}> = ({index, item, isValue, convertToTJ = false}) => {
  return (
    <div style={{margin: '0px 0px 6% 0px'}}>
      <Flex key={index} vertical={true}>
        <Flex
          gap="3%"
          justify="space-around"
          style={{width: '100%'}}
          align="center"
        >
          <CircleComponent color={item?.fill ?? collageOfColors[index]} />
          <div className="scope" style={{width: '100%'}}>
            {item?.label}
          </div>
        </Flex>
        <div className="percentageValue flex" style={{paddingLeft: 20}}>
          {isValue
            ? convertToTJ
              ? convertGjToTjWithUnit(item?.value || 0, item?.unit ?? '')
              : formatIndian(item?.value)
            : item?.percentage}
        </div>
      </Flex>
    </div>
  );
};

export default FlexLegend;
